module.exports = __webpack_public_path__ + "static/media/React.22808bae.png";